//const urlServer='http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com'
const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
//const urlServer='http://localhost:3000'
export const getExportPais = async () =>{
    try{
        let url = `${urlServer}/api/infoPais`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getExportEstado = async (param) =>{
    try{

        let url = `${urlServer}/api/infoEstados?pais=${param['pais']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getExportMunicipio = async (param) =>{
    try{
        let url = `${urlServer}/api/infoMunicipios?pais=${param['pais']}&estado=${param['estado']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getExportAnp = async (param) =>{
    try{
        let url = `${urlServer}/api/infoAnp?pais=${param['pais']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}